import { protectedResources } from '@/authConfig';
import acquireAccessToken from '@/http/Helpers/acquireAccessToken';
import { applyPlaygroundModeHeader } from '@/http/Helpers/playgroundModeHeader';
import {
  handleApiResponse,
  rememberRequestBody
} from '@/http/OpenAPI/clients/staleClaimRetry';
import { paths } from '@/http/OpenAPI/types/bbbee';
import * as Sentry from '@sentry/browser';
import createFetchClient from 'openapi-fetch';
import createClient from 'openapi-react-query';

const { logger } = Sentry;

const scopes = protectedResources.bbbeewebApi.scopes;

const fetchClient = createFetchClient<paths>({
  baseUrl: protectedResources.bbbeewebApi.endpoint
});

fetchClient.use({
  onRequest: async (req) => {
    try {
      const token = await acquireAccessToken(scopes);
      req.request.headers.set('Authorization', `Bearer ${token}`);
      applyPlaygroundModeHeader(req.request);
      // Buffer the body while it is still readable — a 403 replay cannot clone a Request
      // that fetch has already consumed (ADO #7699).
      await rememberRequestBody(req.request);
    } catch (error) {
      logger.error('Failed to acquire access token for bbbee API', { error });
      throw error; // Rethrow to prevent unauthorized requests
    }
  },
  onResponse: (ctx) => handleApiResponse(ctx, { api: 'bbbee', scopes }),
  onError: async (err) => {
    logger.error('Error occurred in bbbee fetch client', {
      error: err,
      api: 'bbbee'
    });
  }
});

export const $bbbeeWebApi = createClient(fetchClient);

export { fetchClient as bbbeeOpenApiClient };
